import { render, staticRenderFns } from "./CoreAdvantages.vue?vue&type=template&id=8e2d0340&scoped=true"
import script from "./CoreAdvantages.vue?vue&type=script&lang=js"
export * from "./CoreAdvantages.vue?vue&type=script&lang=js"
import style0 from "./CoreAdvantages.vue?vue&type=style&index=0&id=8e2d0340&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2d0340",
  null
  
)

export default component.exports